// import React, { useState, useEffect, useMemo } from "react";
// import { Spinner, Form, Button, Dropdown, Table, Pagination, Card, Badge, InputGroup } from "react-bootstrap";
// import * as XLSX from 'xlsx';
// import { FaSearch, FaTimes } from 'react-icons/fa';

// export default function TradeSummery() {
//   const [loading, setLoading] = useState(false);
//   const [fromDate, setFromDate] = useState('');
//   const [toDate, setToDate] = useState('');
//   const [codes, setCodes] = useState('');
//   const [exchange, setExchange] = useState('');
//   const [segment, setSegment] = useState('');
//   const [buySell, setBuySell] = useState('');
//   const [allRecords, setAllRecords] = useState([]);
//   const [filteredRecords, setFilteredRecords] = useState([]);
//   const [pageSize, setPageSize] = useState(10);
//   const [currentPage, setCurrentPage] = useState(1);

//   // Format date to YYYY-MM-DD
//   const formatDate = (dateStr) => {
//     if (!dateStr) return '';
//     const date = new Date(dateStr);
//     const day = String(date.getDate()).padStart(2, '0');
//     const month = String(date.getMonth() + 1).padStart(2, '0');
//     const year = date.getFullYear();
//     return `${year}-${month}-${day}`;
//   };

//   const fetchDataByDate = async () => {
//     if (!fromDate && !toDate) {
//       alert("Please select at least one date");
//       return;
//     }

//     setLoading(true);
//     try {
//       const params = new URLSearchParams();
//       if (fromDate) params.append('fromDate', fromDate);
//       if (toDate) params.append('toDate', toDate);

//       const response = await fetch(`http://183.182.84.228:4005/tradeslip/?${params.toString()}`);
//       if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
      
//       const data = await response.json();
//       setAllRecords(data);
//       applySummarization(data);
//     } catch (error) {
//       console.error("Error fetching data:", error);
//       alert(`Error: ${error.message}`);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Summarize the data by grouping by usercode only
//   const applySummarization = (records) => {
//     const grouped = {};
//     const tradeDates = {};
    
//     records.forEach((rec) => {
//       const usercode = rec.usercode;
      
//       if (!grouped[usercode]) {
//         grouped[usercode] = {
//           usercode: usercode,
//           buyQty: 0,
//           buyAmount: 0,
//           sellQty: 0,
//           sellAmount: 0,
//           tradeDates: new Set()
//         };
//       }
      
//       const rate = parseFloat(rec.rate) || 0;
//       const qty = parseFloat(rec.tradedqty) || 0;
      
//       if (["B", "BUY"].includes(rec.buy_sell?.toUpperCase())) {
//         grouped[usercode].buyQty += qty;
//         grouped[usercode].buyAmount += (rate * qty);
//       } else if (["S", "SELL"].includes(rec.buy_sell?.toUpperCase())) {
//         grouped[usercode].sellQty += qty;
//         grouped[usercode].sellAmount += (rate * qty);
//       }
      
//       // Add trade date to the set
//       if (rec.tradedate) {
//         grouped[usercode].tradeDates.add(rec.tradedate);
//       }
//     });

//     const summarized = Object.values(grouped).map((item) => ({
//       usercode: item.usercode,
//       buyQty: item.buyQty.toFixed(2),
//       avgBuyRate: item.buyQty ? (item.buyAmount / item.buyQty).toFixed(2) : "-",
//       buyAmount: item.buyAmount.toFixed(2),
//       sellQty: item.sellQty.toFixed(2),
//       avgSellRate: item.sellQty ? (item.sellAmount / item.sellQty).toFixed(2) : "-",
//       sellAmount: item.sellAmount.toFixed(2),
//       netQty: (item.buyQty - item.sellQty).toFixed(2),
//       netAmount: (item.buyAmount - item.sellAmount).toFixed(2),
//       tradeDates: Array.from(item.tradeDates).sort().join(", ")
//     })).sort((a, b) => {
//       // Sorting by usercode
//       const usercodeA = a.usercode || "";
//       const usercodeB = b.usercode || "";
//       return usercodeA.localeCompare(usercodeB);
//     });

//     setFilteredRecords(summarized);
//   };

//   const applyFrontendFilters = () => {
//     let filtered = [...allRecords];
    
//     if (codes) {
//       const codeList = codes.split(',').map(code => code.trim());
//       filtered = filtered.filter(record => 
//         codeList.includes(record.usercode)
//       );
//     }
    
//     if (exchange) {
//       filtered = filtered.filter(record => 
//         record.exchange === exchange
//       );
//     }
    
//     if (segment) {
//       filtered = filtered.filter(record => 
//         record.segment === segment
//       );
//     }
    
//     if (buySell) {
//       filtered = filtered.filter(record => {
//         const normalizedRecordValue = record.buy_sell?.charAt(0).toUpperCase();
//         const normalizedFilterValue = buySell.charAt(0).toUpperCase();
//         return normalizedRecordValue === normalizedFilterValue;
//       });
//     }
    
//     applySummarization(filtered);
//     setCurrentPage(1);
//   };

//   useEffect(() => {
//     if (allRecords.length > 0) {
//       applyFrontendFilters();
//     }
//   }, [codes, exchange, segment, buySell, allRecords]);

//   const handleDownload = () => {
//     if (filteredRecords.length === 0) {
//       alert("No data to download");
//       return;
//     }

//     const sheetName = 'Trade Summary';
//     const currentDate = new Date();
//     const formattedDate = `${currentDate.getDate()}-${currentDate.getMonth() + 1}-${currentDate.getFullYear()}`;
    
//     const data = [
//       ["User Code", "Buy Qty", "Avg Buy Rate", "Buy Amount", 
//        "Sell Qty", "Avg Sell Rate", "Sell Amount", 
//        "Net Qty", "Net Amount", "Trade Dates"],
//       ...filteredRecords.map((rec) => [
//         rec.usercode,
//         rec.buyQty, rec.avgBuyRate, rec.buyAmount,
//         rec.sellQty, rec.avgSellRate, rec.sellAmount,
//         rec.netQty, rec.netAmount,
//         rec.tradeDates
//       ]),
//     ];
    
//     const ws = XLSX.utils.aoa_to_sheet(data);
//     const wb = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(wb, ws, sheetName);
//     XLSX.writeFile(wb, `Trade_Summary_${formattedDate}.xlsx`);
//   };

//   // Set default dates to previous working day
//   useEffect(() => {
//     if (!fromDate && !toDate) {
//       const today = new Date();
//       let previousWorkingDay = new Date(today);
      
//       // Loop backwards to find the previous weekday (Mon-Fri)
//       do {
//         previousWorkingDay.setDate(previousWorkingDay.getDate() - 1);
//       } while (previousWorkingDay.getDay() === 0 || previousWorkingDay.getDay() === 6);
      
//       const formatted = formatInputDate(previousWorkingDay);
//       setFromDate(formatted);
//       setToDate(formatted);
//     }
//   }, []);

//   const formatInputDate = (date) => date.toISOString().split("T")[0];

//   const paginatedRecords = filteredRecords.slice(
//     (currentPage - 1) * pageSize,
//     currentPage * pageSize
//   );
//   const totalPages = Math.ceil(filteredRecords.length / pageSize);

//   const uniqueExchanges = [...new Set(allRecords.map(item => item.exchange))].filter(Boolean).sort();
//   const uniqueSegments = [...new Set(allRecords.map(item => item.segment))].filter(Boolean).sort();
//   const uniqueCodes = [...new Set(allRecords.map(item => item.usercode))].filter(Boolean).sort();

//   return (
//     <div>
//       <Card>
//         <Card.Header>
//           <h4>Trade Records Filter</h4>
//         </Card.Header>
//         <Card.Body>
//           {/* Date Filter Section */}
//           <div className="row g-3">
//             <div className="col-md-3">
//               <Form.Group>
//                 <Form.Label>From Date</Form.Label>
//                 <Form.Control
//                   type="date"
//                   value={fromDate}
//                   onChange={(e) => setFromDate(e.target.value)}
//                 />
//               </Form.Group>
//             </div>
//             <div className="col-md-3">
//               <Form.Group>
//                 <Form.Label>To Date</Form.Label>
//                 <Form.Control
//                   type="date"
//                   value={toDate}
//                   onChange={(e) => setToDate(e.target.value)}
//                   min={fromDate}
//                 />
//               </Form.Group>
//             </div>
//             <div className="col-md-3 d-flex align-items-end">
//               <Button
//                 variant="primary"
//                 onClick={fetchDataByDate}
//                 disabled={loading || (!fromDate && !toDate)}
//               >
//                 {loading ? (
//                   <>
//                     <Spinner as="span" size="sm" animation="border" />
//                     <span className="ms-2">Loading...</span>
//                   </>
//                 ) : (
//                   "Fetch Data"
//                 )}
//               </Button>
//             </div>
//           </div>

//           {/* Frontend Filters Section */}
//           {allRecords.length > 0 && (
//             <>
//               <div className="row g-3 mt-3">
//                 <div className="col-md-2">
//                   <Form.Group>
//                     <Form.Label>Exchange</Form.Label>
//                     <Form.Select
//                       value={exchange}
//                       onChange={(e) => setExchange(e.target.value)}
//                     >
//                       <option value="">All Exchanges</option>
//                       {uniqueExchanges.map((ex, idx) => (
//                         <option key={idx} value={ex}>{ex}</option>
//                       ))}
//                     </Form.Select>
//                   </Form.Group>
//                 </div>
//                 <div className="col-md-2">
//                   <Form.Group>
//                     <Form.Label>Segment</Form.Label>
//                     <Form.Select
//                       value={segment}
//                       onChange={(e) => setSegment(e.target.value)}
//                     >
//                       <option value="">All Segments</option>
//                       {uniqueSegments.map((seg, idx) => (
//                         <option key={idx} value={seg}>{seg}</option>
//                       ))}
//                     </Form.Select>
//                   </Form.Group>
//                 </div>
//                 <div className="col-md-2">
//                   <Form.Group>
//                     <Form.Label>Buy/Sell</Form.Label>
//                     <Form.Select
//                       value={buySell}
//                       onChange={(e) => setBuySell(e.target.value)}
//                     >
//                       <option value="">All</option>
//                       <option value="B">B / Buy</option>
//                       <option value="S">S / Sell</option>
//                     </Form.Select>
//                   </Form.Group>
//                 </div>
//                 <div className="col-md-3">
//                   <Form.Group>
//                     <Form.Label>User Codes</Form.Label>
//                     <Form.Control
//                       type="text"
//                       placeholder="ABC123, DEF456"
//                       value={codes}
//                       onChange={(e) => setCodes(e.target.value)}
//                       list="codeOptions"
//                     />
//                     <datalist id="codeOptions">
//                       {uniqueCodes.map((code, idx) => (
//                         <option key={idx} value={code} />
//                       ))}
//                     </datalist>
//                   </Form.Group>
//                 </div>
//               </div>

//               <div className="d-flex gap-2 mt-3">
//                 <Button variant="outline-secondary" onClick={() => {
//                   setCodes('');
//                   setExchange('');
//                   setSegment('');
//                   setBuySell('');
//                   applySummarization(allRecords);
//                 }}>
//                   Clear All Filters
//                 </Button>
//                 <Button variant="success" onClick={handleDownload}>
//                   Download Excel
//                 </Button>
//               </div>
//             </>
//           )}
//         </Card.Body>
//       </Card>

//       {/* Results Table */}
//       {filteredRecords.length > 0 && (
//         <div className="mt-4">
//           <Card>
//             <Card.Header className="d-flex justify-content-between align-items-center">
//               <h5>Trade Summary by User Code</h5>
//               <Badge bg="primary">
//                 Total Records: {filteredRecords.length}
//               </Badge>
//             </Card.Header>
//             <Card.Body>
//               <div className="d-flex justify-content-between mb-3">
//                 <div className="d-flex align-items-center">
//                   <span className="me-2">Show</span>
//                   <Form.Select
//                     size="sm"
//                     style={{ width: '80px' }}
//                     value={pageSize}
//                     onChange={(e) => setPageSize(Number(e.target.value))}
//                   >
//                     <option value="10">10</option>
//                     <option value="25">25</option>
//                     <option value="50">50</option>
//                     <option value="100">100</option>
//                   </Form.Select>
//                   <span className="ms-2">entries</span>
//                 </div>
//               </div>

//               <div className="table-responsive rounded-3 shadow-sm border-0"
//                 style={{
//                   maxHeight: 'calc(100vh - 250px)',
//                   overflowY: 'auto',
//                   scrollBehavior: 'smooth',
//                 }}
//               >
//                 <Table striped bordered hover className="mb-0">
//                   <thead style={{
//                     position: 'sticky',
//                     top: 0,
//                     zIndex: 10,
//                     backgroundColor: 'white',
//                     boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
//                   }}>
//                     <tr>
//                       <th>User Code</th>
//                       <th>Buy Qty</th>
//                       <th>Avg Buy Rate</th>
//                       <th>Buy Amount</th>
//                       <th>Sell Qty</th>
//                       <th>Avg Sell Rate</th>
//                       <th>Sell Amount</th>
//                       <th>Net Qty</th>
//                       <th>Net Amount</th>
//                       <th>Trade Dates</th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {paginatedRecords.map((record, index) => (
//                       <tr key={index}>
//                         <td>{record.usercode}</td>
//                         <td>{record.buyQty}</td>
//                         <td>{record.avgBuyRate}</td>
//                         <td>{record.buyAmount}</td>
//                         <td>{record.sellQty}</td>
//                         <td>{record.avgSellRate}</td>
//                         <td>{record.sellAmount}</td>
//                         <td>{record.netQty}</td>
//                         <td>{record.netAmount}</td>
//                         <td>{record.tradeDates}</td>
//                       </tr>
//                     ))}
//                   </tbody>
//                 </Table>
//               </div>

//               <div className="d-flex justify-content-between mt-3">
//                 <div>
//                   Showing {((currentPage - 1) * pageSize) + 1} to{' '}
//                   {Math.min(currentPage * pageSize, filteredRecords.length)} of{' '}
//                   {filteredRecords.length} entries
//                 </div>
//                 <Pagination>
//                   <Pagination.First 
//                     onClick={() => setCurrentPage(1)} 
//                     disabled={currentPage === 1} 
//                   />
//                   <Pagination.Prev 
//                     onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))} 
//                     disabled={currentPage === 1} 
//                   />
//                   <Pagination.Item disabled>
//                     Page {currentPage} of {totalPages}
//                   </Pagination.Item>
//                   <Pagination.Next 
//                     onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))} 
//                     disabled={currentPage === totalPages} 
//                   />
//                   <Pagination.Last 
//                     onClick={() => setCurrentPage(totalPages)} 
//                     disabled={currentPage === totalPages} 
//                   />
//                 </Pagination>
//               </div>
//             </Card.Body>
//           </Card>
//         </div>
//       )}
//     </div>
//   );
// }










import React, { useState, useEffect } from "react";
import { Spinner, Form, Button, Table, Pagination, Card, Badge } from "react-bootstrap";
import * as XLSX from 'xlsx';

export default function TradeSummery() {
  const [loading, setLoading] = useState(false);
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [codes, setCodes] = useState('');
  const [exchange, setExchange] = useState('');
  const [segment, setSegment] = useState('');
  const [buySell, setBuySell] = useState('');
  const [allRecords, setAllRecords] = useState([]);
  const [filteredRecords, setFilteredRecords] = useState([]);
  const [pageSize, setPageSize] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);

  // Format date to YYYY-MM-DD
  const formatDate = (dateStr) => {
    if (!dateStr) return '';
    const date = new Date(dateStr);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${year}-${month}-${day}`;
  };

  const fetchDataByDate = async () => {
    if (!fromDate && !toDate) {
      alert("Please select at least one date");
      return;
    }

    setLoading(true);
    try {
      const params = new URLSearchParams();
      if (fromDate) params.append('fromDate', fromDate);
      if (toDate) params.append('toDate', toDate);

      const response = await fetch(`http://183.182.84.228:4005/tradeslip/?${params.toString()}`);
      if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
      
      const data = await response.json();
      setAllRecords(data);
      applySummarization(data);
    } catch (error) {
      console.error("Error fetching data:", error);
      alert(`Error: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  // Summarize the data by grouping by usercode and trade date
  const applySummarization = (records) => {
    const grouped = {};
    
    records.forEach((rec) => {
      const usercode = rec.usercode;
      const tradeDate = rec.tradedate || 'Unknown Date';
      const key = `${usercode}_${tradeDate}`;
      
      if (!grouped[key]) {
        grouped[key] = {
          usercode: usercode,
          tradeDate: tradeDate,
          buyQty: 0,
          buyAmount: 0,
          sellQty: 0,
          sellAmount: 0,
        };
      }
      
      const rate = parseFloat(rec.rate) || 0;
      const qty = parseFloat(rec.tradedqty) || 0;
      
      if (["B", "BUY"].includes(rec.buy_sell?.toUpperCase())) {
        grouped[key].buyQty += qty;
        grouped[key].buyAmount += (rate * qty);
      } else if (["S", "SELL"].includes(rec.buy_sell?.toUpperCase())) {
        grouped[key].sellQty += qty;
        grouped[key].sellAmount += (rate * qty);
      }
    });

    const summarized = Object.values(grouped).map((item) => ({
      usercode: item.usercode,
      tradeDate: item.tradeDate,
      buyQty: item.buyQty.toFixed(2),
      avgBuyRate: item.buyQty ? (item.buyAmount / item.buyQty).toFixed(2) : "-",
      buyAmount: item.buyAmount.toFixed(2),
      sellQty: item.sellQty.toFixed(2),
      avgSellRate: item.sellQty ? (item.sellAmount / item.sellQty).toFixed(2) : "-",
      sellAmount: item.sellAmount.toFixed(2),
      netQty: (item.buyQty - item.sellQty).toFixed(2),
      netAmount: (item.buyAmount - item.sellAmount).toFixed(2)
    })).sort((a, b) => {
      // Sort by usercode first, then by date
      const usercodeCompare = (a.usercode || "").localeCompare(b.usercode || "");
      if (usercodeCompare !== 0) return usercodeCompare;
      return (a.tradeDate || "").localeCompare(b.tradeDate || "");
    });

    setFilteredRecords(summarized);
  };

  const applyFrontendFilters = () => {
    let filtered = [...allRecords];
    
    if (codes) {
      const codeList = codes.split(',').map(code => code.trim());
      filtered = filtered.filter(record => 
        codeList.includes(record.usercode)
      );
    }
    
    if (exchange) {
      filtered = filtered.filter(record => 
        record.exchange === exchange
      );
    }
    
    if (segment) {
      filtered = filtered.filter(record => 
        record.segment === segment
      );
    }
    
    if (buySell) {
      filtered = filtered.filter(record => {
        const normalizedRecordValue = record.buy_sell?.charAt(0).toUpperCase();
        const normalizedFilterValue = buySell.charAt(0).toUpperCase();
        return normalizedRecordValue === normalizedFilterValue;
      });
    }
    
    applySummarization(filtered);
    setCurrentPage(1);
  };

  useEffect(() => {
    if (allRecords.length > 0) {
      applyFrontendFilters();
    }
  }, [codes, exchange, segment, buySell, allRecords]);

  const handleDownload = () => {
    if (filteredRecords.length === 0) {
      alert("No data to download");
      return;
    }

    const sheetName = 'Trade Summary';
    const currentDate = new Date();
    const formattedDate = `${currentDate.getDate()}-${currentDate.getMonth() + 1}-${currentDate.getFullYear()}`;
    
    const data = [
      ["User Code", "Trade Date", "Buy Qty", "Avg Buy Rate", "Buy Amount", 
       "Sell Qty", "Avg Sell Rate", "Sell Amount", 
       "Net Qty", "Net Amount"],
      ...filteredRecords.map((rec) => [
        rec.usercode,
        rec.tradeDate,
        rec.buyQty, rec.avgBuyRate, rec.buyAmount,
        rec.sellQty, rec.avgSellRate, rec.sellAmount,
        rec.netQty, rec.netAmount
      ]),
    ];
    
    const ws = XLSX.utils.aoa_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, sheetName);
    XLSX.writeFile(wb, `Trade_Summary_${formattedDate}.xlsx`);
  };

  // Set default dates to previous working day
  useEffect(() => {
    if (!fromDate && !toDate) {
      const today = new Date();
      let previousWorkingDay = new Date(today);
      
      // Loop backwards to find the previous weekday (Mon-Fri)
      do {
        previousWorkingDay.setDate(previousWorkingDay.getDate() - 1);
      } while (previousWorkingDay.getDay() === 0 || previousWorkingDay.getDay() === 6);
      
      const formatted = formatInputDate(previousWorkingDay);
      setFromDate(formatted);
      setToDate(formatted);
    }
  }, []);

  const formatInputDate = (date) => date.toISOString().split("T")[0];

  const paginatedRecords = filteredRecords.slice(
    (currentPage - 1) * pageSize,
    currentPage * pageSize
  );
  const totalPages = Math.ceil(filteredRecords.length / pageSize);

  const uniqueExchanges = [...new Set(allRecords.map(item => item.exchange))].filter(Boolean).sort();
  const uniqueSegments = [...new Set(allRecords.map(item => item.segment))].filter(Boolean).sort();
  const uniqueCodes = [...new Set(allRecords.map(item => item.usercode))].filter(Boolean).sort();

  return (
    <div>
      <Card>
        <Card.Header>
          <h4>Trade Records Filter</h4>
        </Card.Header>
        <Card.Body>
          {/* Date Filter Section */}
          <div className="row g-3">
            <div className="col-md-3">
              <Form.Group>
                <Form.Label>From Date</Form.Label>
                <Form.Control
                  type="date"
                  value={fromDate}
                  onChange={(e) => setFromDate(e.target.value)}
                />
              </Form.Group>
            </div>
            <div className="col-md-3">
              <Form.Group>
                <Form.Label>To Date</Form.Label>
                <Form.Control
                  type="date"
                  value={toDate}
                  onChange={(e) => setToDate(e.target.value)}
                  min={fromDate}
                />
              </Form.Group>
            </div>
            <div className="col-md-3 d-flex align-items-end">
              <Button
                variant="primary"
                onClick={fetchDataByDate}
                disabled={loading || (!fromDate && !toDate)}
              >
                {loading ? (
                  <>
                    <Spinner as="span" size="sm" animation="border" />
                    <span className="ms-2">Loading...</span>
                  </>
                ) : (
                  "Fetch Data"
                )}
              </Button>
            </div>
          </div>

          {/* Frontend Filters Section */}
          {allRecords.length > 0 && (
            <>
              <div className="row g-3 mt-3">
                <div className="col-md-2">
                  <Form.Group>
                    <Form.Label>Exchange</Form.Label>
                    <Form.Select
                      value={exchange}
                      onChange={(e) => setExchange(e.target.value)}
                    >
                      <option value="">All Exchanges</option>
                      {uniqueExchanges.map((ex, idx) => (
                        <option key={idx} value={ex}>{ex}</option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </div>
                <div className="col-md-2">
                  <Form.Group>
                    <Form.Label>Segment</Form.Label>
                    <Form.Select
                      value={segment}
                      onChange={(e) => setSegment(e.target.value)}
                    >
                      <option value="">All Segments</option>
                      {uniqueSegments.map((seg, idx) => (
                        <option key={idx} value={seg}>{seg}</option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </div>
                <div className="col-md-2">
                  <Form.Group>
                    <Form.Label>Buy/Sell</Form.Label>
                    <Form.Select
                      value={buySell}
                      onChange={(e) => setBuySell(e.target.value)}
                    >
                      <option value="">All</option>
                      <option value="B">B / Buy</option>
                      <option value="S">S / Sell</option>
                    </Form.Select>
                  </Form.Group>
                </div>
                <div className="col-md-3">
                  <Form.Group>
                    <Form.Label>User Codes</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="ABC123, DEF456"
                      value={codes}
                      onChange={(e) => setCodes(e.target.value)}
                      list="codeOptions"
                    />
                    <datalist id="codeOptions">
                      {uniqueCodes.map((code, idx) => (
                        <option key={idx} value={code} />
                      ))}
                    </datalist>
                  </Form.Group>
                </div>
              </div>

              <div className="d-flex gap-2 mt-3">
                <Button variant="outline-secondary" onClick={() => {
                  setCodes('');
                  setExchange('');
                  setSegment('');
                  setBuySell('');
                  applySummarization(allRecords);
                }}>
                  Clear All Filters
                </Button>
                <Button variant="success" onClick={handleDownload}>
                  Download Excel
                </Button>
              </div>
            </>
          )}
        </Card.Body>
      </Card>

      {/* Results Table */}
      {filteredRecords.length > 0 && (
        <div className="mt-4">
          <Card>
            <Card.Header className="d-flex justify-content-between align-items-center">
              <h5>Trade Summary by User Code and Date</h5>
              <Badge bg="primary">
                Total Records: {filteredRecords.length}
              </Badge>
            </Card.Header>
            <Card.Body>
              <div className="d-flex justify-content-between mb-3">
                <div className="d-flex align-items-center">
                  <span className="me-2">Show</span>
                  <Form.Select
                    size="sm"
                    style={{ width: '80px' }}
                    value={pageSize}
                    onChange={(e) => setPageSize(Number(e.target.value))}
                  >
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </Form.Select>
                  <span className="ms-2">entries</span>
                </div>
              </div>

              <div className="table-responsive rounded-3 shadow-sm border-0"
                style={{
                  maxHeight: 'calc(100vh - 250px)',
                  overflowY: 'auto',
                  scrollBehavior: 'smooth',
                }}
              >
                <Table striped bordered hover className="mb-0">
                  <thead style={{
                    position: 'sticky',
                    top: 0,
                    zIndex: 10,
                    backgroundColor: 'white',
                    boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
                  }}>
                    <tr>
                      <th>User Code</th>
                      <th>Trade Date</th>
                      <th>Buy Qty</th>
                      <th>Avg Buy Rate</th>
                      <th>Buy Amount</th>
                      <th>Sell Qty</th>
                      <th>Avg Sell Rate</th>
                      <th>Sell Amount</th>
                      <th>Net Qty</th>
                      <th>Net Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    {paginatedRecords.map((record, index) => (
                      <tr key={index}>
                        <td>{record.usercode}</td>
                        <td>{record.tradeDate}</td>
                        <td>{record.buyQty}</td>
                        <td>{record.avgBuyRate}</td>
                        <td>{record.buyAmount}</td>
                        <td>{record.sellQty}</td>
                        <td>{record.avgSellRate}</td>
                        <td>{record.sellAmount}</td>
                        <td>{record.netQty}</td>
                        <td>{record.netAmount}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>

              <div className="d-flex justify-content-between mt-3">
                <div>
                  Showing {((currentPage - 1) * pageSize) + 1} to{' '}
                  {Math.min(currentPage * pageSize, filteredRecords.length)} of{' '}
                  {filteredRecords.length} entries
                </div>
                <Pagination>
                  <Pagination.First 
                    onClick={() => setCurrentPage(1)} 
                    disabled={currentPage === 1} 
                  />
                  <Pagination.Prev 
                    onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))} 
                    disabled={currentPage === 1} 
                  />
                  <Pagination.Item disabled>
                    Page {currentPage} of {totalPages}
                  </Pagination.Item>
                  <Pagination.Next 
                    onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))} 
                    disabled={currentPage === totalPages} 
                  />
                  <Pagination.Last 
                    onClick={() => setCurrentPage(totalPages)} 
                    disabled={currentPage === totalPages} 
                  />
                </Pagination>
              </div>
            </Card.Body>
          </Card>
        </div>
      )}
    </div>
  );
}